<template>
  <div class="row">
    <div class="col-lg-6 m-auto">
      <o-card :title="$t('sandoz.two_factor_autnetication')">
        <form @submit.prevent="confirmPassword" @keydown="form.onKeydown($event)">
          <div class="form-group row" v-if="form.user_id">
            <div class="col-md-4 m-auto">
              <div>
                <input v-model="form.password" type="password" class="form-control mt-1"
                  :class="!validation ? 'is-invalid': ''" :placeholder="$t('sandoz.two_factor_verification_code')" autofocus>
                <b-form-invalid-feedback :state="validation">
                  {{ $t('sandoz.two_factor_confirmation_error') }}
                </b-form-invalid-feedback>
                <o-button :loading="form.busy" class="mr-3 mt-2">
                  {{ $t('sandoz.validate_2FA') }}
                </o-button>
              </div>
            </div>
          </div>
        </form>
      </o-card>
    </div>
  </div>
</template>
  
<style>
  .max-width-65 {
    max-width: 65%;
  }
</style>

<script>
    import Form from 'vform'
    import axios from 'axios'
    import {setLocale} from '~/plugins/i18n'

    export default {
      data: () => ({
        tokenUserID: null,
        validation: true,
        form: new Form({
          password: '',
          user_id: null
        })
      }),
  
      created() {
        // check token is set then get QR code
        var token = this.$localStorage.get('jwt-token')
        this.form.user_id = this.$localStorage.get('jwt-token-userid')
        if (!token || this.form.user_id === null) {
          this.$router.push({name: 'home'})
        }
      },

      methods: {
        async confirmPassword() {
          if(this.form.password === '') {
            this.validation = false
          } else {
            const {data} = await this.form.post('/api/settings/confirm-password-login')
            if(data.success) {
              this.validation = true
              this.login()
            } else {
              this.validation = false
            }
          }
        },
        async login() {
          var token = this.$localStorage.get('jwt-token')
          var tokenRemember = this.$localStorage.get('jwt-token-remember')
          
          // Save the token.
          this.$store.dispatch('auth/saveToken', {
            token: token,
            remember: tokenRemember
          })

          this.$localStorage.remove('jwt-token');
          this.$localStorage.remove('jwt-token-remember');
          this.$localStorage.remove('jwt-token-userid');

          // Fetch the user.
          await this.$store.dispatch('auth/fetchUser')

          let lang = this.$store.state['auth']['user']['language']
          if (lang !== null && this.$i18n.locale !== lang) {
            setLocale(lang)
            this.$store.dispatch('lang/setLocale', { 'locale': lang })
          }

          // Redirect to previous page or home in case nothing was specified
          if (this.$route.query && this.$route.query.from) {
            this.$router.push(this.$route.query.from)
          } else {
            this.$router.push({name: 'home'})
          }
          // Redirect to previous page or home in case nothing was specified
          this.$router.go()
        }
      }
    }
</script>
  